import React, {FormEvent, useRef, useState} from 'react';

import {ActivityButton} from './ActivityButton';
import {Input} from './Input';
import {Flow, FlowFetchResponse} from '../_services/Flow';

export interface LoginFormProps {
    initialValues?: LoginFormValues,
    onSubmit?: LoginFormSubmit,
    isWorking?: boolean
}

export interface LoginFormValues {
    email: string;
    password: string;
}

const defaultFormValues: LoginFormValues = {
    email: '',
    password: ''
};

export type LoginFormSubmit = (formValues: LoginFormValues) => void;

export const LoginForm: React.FunctionComponent<LoginFormProps> = ({
                                                                       initialValues = defaultFormValues,
                                                                       onSubmit,
                                                                       isWorking = false,
                                                                   }) => {
    const passwordInputRef = useRef(null);
    const [formValues, setFormValues] = useState(initialValues);
    const [otpIsWorking, setOtpIsWorking] = useState<boolean>(false);
    const [otpSent, setOtpSent] = useState<boolean>(false);
    const [otpMessage, setOtpMessage] = useState<string>('');

    const emailIsValid = (email: string) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
    const sendOtp = (email: string) => {
        setOtpIsWorking(true);
        setOtpMessage('');
        setOtpSent(false);

        Flow.getInstance().sendOtp(email)
            .then((response: FlowFetchResponse) => {
                if (response.ok) {
                    setOtpMessage('A One-Time Password has been sent to your email. Please enter the password below and click "Sign in"');
                    setOtpSent(true);
                } else {
                    throw Error(response?.json?.message || 'Error generating a One-Time Password. Please try again');
                }
            })
            .catch((error: any) => {
                setOtpMessage(error?.message || error || 'Error generating a One-Time Password. Please try again');
            })
            .finally(() => {
                setOtpIsWorking(false);
            });
    };

    return (
        <form className="form-signin" onSubmit={(e) => {
            e.preventDefault();
        }}>
            {otpMessage && <div className="alert-info p-2 mb-2">{otpMessage}</div>}
            <Input
                type="email"
                name="email"
                placeholder="Email address"
                autoFocus={true}
                required={true}
                value={formValues.email || ''}
                onChange={(e: FormEvent<HTMLInputElement>) => {
                    const val = e.currentTarget.value.toLowerCase();
                    setFormValues((state) => ({...state, email: val}));
                }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' && passwordInputRef) {
                        // @ts-ignore
                        passwordInputRef?.current?.focus();
                    }
                }}
                className={formValues?.email?.match(/abb\.com$/) ? 'has-password' : ''}
            />
            {(
                (
                    (
                        formValues.email.toLowerCase() !== 'epis.mdm.team@abb.com' &&
                        formValues.email.toLowerCase() !== 'epis.parts@abb.com' &&
                        formValues.email.toLowerCase() !== 'epis.salemcscs@abb.com' &&
                        formValues.email.toLowerCase() !== 'mro.st-jean@ca.abb.com'
                    ) && formValues.email.match(/abb\.com$/)
                ) ||
                otpSent
            ) &&
            <div className="form-group">
                <input type="password"
                       name="password"
                       className="form-control"
                       placeholder="Password"
                       ref={passwordInputRef}
                       required={true}
                       value={formValues.password || ''}
                       onChange={(e: FormEvent<HTMLInputElement>) => {
                           const val = e.currentTarget.value;
                           setFormValues((state) => ({...state, password: val}));
                       }}
                       onKeyDown={(e) => {
                           if (e.key === 'Enter') {
                               onSubmit && onSubmit(formValues)
                           }
                       }}
                />
            </div>
            }
            <div className="form-group mt-3">
                <ActivityButton className="btn btn-lg btn-secondary btn-block"
                                isActive={isWorking || otpIsWorking}
                                onClick={() => {
                                    if (
                                        !formValues?.password &&
                                        (
                                            formValues?.email.toLowerCase() === 'epis.mdm.team@abb.com' ||
                                            formValues?.email.toLowerCase() === 'epis.parts@abb.com' ||
                                            formValues?.email.toLowerCase() === 'epis.salemcscs@abb.com' ||
                                            formValues?.email.toLowerCase() === 'mro.st-jean@ca.abb.com' ||
                                            !formValues.email.match(/abb\.com$/)
                                        )
                                    ) {
                                        sendOtp(formValues?.email);
                                    } else {
                                        onSubmit && onSubmit(formValues)
                                    }
                                }}
                                disabled={!emailIsValid(formValues?.email)}
                >Sign in
                </ActivityButton>
            </div>
        </form>
    );
};